"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getBaseURL(url) {
    url = url || window.location.href;
    if (url.indexOf('?') > -1) {
        url = url.substr(0, url.indexOf('?'));
    }
    return url;
}
exports.getBaseURL = getBaseURL;
